import AuthorizedRoute from 'Components/AuthorizedRoute';
import { SITE_PAGES } from 'Config';
import withRouter from 'Lib/hoc/withRouter';
import { Navigate, Route, Routes } from 'react-router';
import { isUserAuthorized } from 'Util';
import AllOrdersListView from './AllOrdersListView';
import MyOrdersListView from './MyOrdersListView';
import NewRequestView from './NewRequestView';
import RequestDetails from './RequestDetails';
import RequestListView from './RequestListView';

let OrderDetailWithRouter = withRouter(RequestDetails);

const Requests = () => {
  return (
    <Routes>
      <Route path='/' element={<Navigate to='all' replace />} />
      <Route
        path='new'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.NEW_ORDER.requiredAuth}>
            <NewRequestView />
          </AuthorizedRoute>
        }
      />
      <Route
        path='all'
        element={
          isUserAuthorized(SITE_PAGES.ALL_ORDERS.requiredAuth) ? (
            <AuthorizedRoute requiredAuth={SITE_PAGES.ALL_ORDERS.requiredAuth}>
              <AllOrdersListView />
            </AuthorizedRoute>
          ) : (
            <Navigate replace to={SITE_PAGES.MY_ORDERS.to} />
          )
        }
      />
      <Route
        path='all/:id'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.ORDER_DETAIL.requiredAuth}>
            <OrderDetailWithRouter />
          </AuthorizedRoute>
        }
      />
      <Route
        path='requests'
        element={
          <AuthorizedRoute
            requiredAuth={SITE_PAGES.REQUEST_ORDERS.requiredAuth}>
            <RequestListView />
          </AuthorizedRoute>
        }
      />
      <Route
        path='requests/:id'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.ORDER_DETAIL.requiredAuth}>
            <OrderDetailWithRouter />
          </AuthorizedRoute>
        }
      />
      <Route
        path='mine'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.MY_ORDERS.requiredAuth}>
            <MyOrdersListView />
          </AuthorizedRoute>
        }
      />
    </Routes>
  );
};

let Page = withRouter(Requests);
export default Page;
